function Infrastructure() {
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Infrastructure Page</h1>
    </div>
  );
}

export default Infrastructure;